"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPriceLabel = exports.getRelevantPrice = exports.isProductWithFinalPrice = exports.isProductWithAMCost = exports.isProductWithSupervisorCost = exports.isProductWithBasePrice = void 0;
/**
 * Type guard to check if a product has admin pricing context
 */
function isProductWithBasePrice(product) {
    return product.pricingContext === 'admin';
}
exports.isProductWithBasePrice = isProductWithBasePrice;
/**
 * Type guard to check if a product has supervisor pricing context
 */
function isProductWithSupervisorCost(product) {
    return product.pricingContext === 'supervisor';
}
exports.isProductWithSupervisorCost = isProductWithSupervisorCost;
/**
 * Type guard to check if a product has AM pricing context
 */
function isProductWithAMCost(product) {
    return product.pricingContext === 'am';
}
exports.isProductWithAMCost = isProductWithAMCost;
/**
 * Type guard to check if a product has physician pricing context
 */
function isProductWithFinalPrice(product) {
    return product.pricingContext === 'physician';
}
exports.isProductWithFinalPrice = isProductWithFinalPrice;
/**
 * Helper to get the relevant price from any pricing context
 * Returns the price that should be displayed/used for that context
 */
function getRelevantPrice(product) {
    switch (product.pricingContext) {
        case 'admin':
            return product.basePrice;
        case 'supervisor':
            return product.cost;
        case 'am':
            return product.cost;
        case 'physician':
            return product.finalPrice;
    }
}
exports.getRelevantPrice = getRelevantPrice;
/**
 * Helper to get the price label for any pricing context
 */
function getPriceLabel(product) {
    switch (product.pricingContext) {
        case 'admin':
            return 'Base Price';
        case 'supervisor':
            return 'Your Cost';
        case 'am':
            return 'Your Cost';
        case 'physician':
            return 'Price';
    }
}
exports.getPriceLabel = getPriceLabel;
// Export notification types
__exportStar(require("./notifications"), exports);
//# sourceMappingURL=index.js.map